"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLDFAQSchema = exports.updateShippingAddressSchema = exports.ShipOrderSchema = exports.PromoCodeSchema = exports.SecondaryBannerSchema = exports.HomepageBannerSchema = exports.AddProductCategorySchema = exports.EditProductSchema = exports.AddProductSchema = void 0;
const Yup = __importStar(require("yup"));
const ProductVariationDataObj = Yup.object()
    .shape({
    id: Yup.number(),
    value: Yup.string().min(1, 'Too Short!').required('Value is required'),
    unitPrice: Yup.string()
        .matches(/^\d+(.\d{1,2})?$/, 'Must be valid with 2 decimal places e.g 10.00')
        .required('Unit price is required'),
    unitWeight: Yup.string()
        .matches(/^\d+(.\d{1,1})?$/, 'Must be valid with 1 decimal places e.g 1.0')
        .required('Unit weight is required'),
    unitsInStock: Yup.number().min(0, 'Cannot be a negative value').required('Unit in stock is required'),
})
    .required();
const ProductVariationObj = Yup.object()
    .shape({
    id: Yup.number(),
    name: Yup.string().min(1, 'Too Short!').required('Variation name is required'),
    variationData: Yup.array().of(ProductVariationDataObj).min(1, 'Product option data is required'),
})
    .required();
exports.AddProductSchema = Yup.object()
    .shape({
    id: Yup.number(),
    name: Yup.string().min(1, 'Too Short!').required('Product name is required'),
    description: Yup.string().min(1, 'Too Short!').required('Product description is required'),
    longDescription: Yup.string().min(1, 'Too Short!').required('Product long description is required'),
    category: Yup.array().min(1, 'Product category is required'),
    brand: Yup.string().min(1, 'Too Short!').required('Product brand is required'),
    isDiscount: Yup.boolean().required('Required'),
    discount: Yup.string().matches(/^\d+(.\d{1,2})?$/, 'Must be valid with 2 decimal places e.g 10.00'),
    sku: Yup.string(),
    metaTitle: Yup.string().min(1, 'Too Short!').required('Product meta title is required'),
    metaKeywords: Yup.string().min(1, 'Too Short!').required('Product meta keywords is required'),
    metaDescription: Yup.string().min(50, 'Too Short!').max(160, 'Too Long!').required('Product name is required'),
    variations: Yup.array().of(ProductVariationObj).min(1, 'Product image is required'),
})
    .required();
exports.EditProductSchema = Yup.object()
    .shape({
    id: Yup.number(),
    name: Yup.string().min(1, 'Too Short!').required('Product name is required'),
    description: Yup.string().min(1, 'Too Short!').required('Product description is required'),
    longDescription: Yup.string().min(1, 'Too Short!').required('Product long description is required'),
    category: Yup.array().min(1, 'Product category is required'),
    brand: Yup.string().min(1, 'Too Short!').required('Product brand is required'),
    isDiscount: Yup.boolean().required('Required'),
    discount: Yup.string().matches(/^\d+(.\d{1,2})?$/, 'Must be valid with 2 decimal places e.g 10.00'),
    sku: Yup.string(),
    metaTitle: Yup.string().min(1, 'Too Short!').required('Product meta title is required'),
    metaKeywords: Yup.string().min(1, 'Too Short!').required('Product meta keywords is required'),
    metaDescription: Yup.string().min(50, 'Too Short!').max(160, 'Too Long!').required('Product name is required'),
    variations: Yup.array().of(ProductVariationObj).min(1, 'Product image is required'),
    images: Yup.array(),
    pendingImages: Yup.array().min(1, 'Product image is required'),
})
    .required();
exports.AddProductCategorySchema = Yup.object()
    .shape({
    name: Yup.string().min(1, 'Too Short!').required('Category name is required'),
})
    .required();
exports.HomepageBannerSchema = Yup.object()
    .shape({
    title: Yup.string().min(1, 'Too Short!').max(30, 'Exceed characters limit!').required('Banner title is required'),
    description: Yup.string().min(0, 'Too Short!').max(150, 'Exceed characters limit!'),
    hasProductButton: Yup.boolean().required('Required'),
})
    .required();
exports.SecondaryBannerSchema = Yup.object()
    .shape({
    title: Yup.string().min(1, 'Too Short!').max(30, 'Exceed characters limit!').required('Banner title is required'),
})
    .required();
exports.PromoCodeSchema = Yup.object()
    .shape({
    title: Yup.string().min(1, 'Too Short!').max(30, 'Exceed characters limit!').required('Promo title is required'),
    description: Yup.string().min(0, 'Too Short!').max(150, 'Exceed characters limit!').required('Promo Description is required'),
    code: Yup.string().min(1, 'Too Short!').max(20, 'Exceed characters limit!').required('Promo code is required'),
    quantity: Yup.number().min(1, 'Minimum quantity is 1'),
    isPercentage: Yup.boolean().required('Required'),
    discountPercentage: Yup.number(),
    discountPrice: Yup.string().matches(/^\d+(.\d{1,2})?$/, 'Must be valid with 2 decimal places e.g 10.00'),
    isPromoBanner: Yup.boolean().required('Required'),
})
    .required();
exports.ShipOrderSchema = Yup.object()
    .shape({
    courierProvider: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('Courier provider is required'),
    trackingNumber: Yup.string().min(1, 'Too Short!').max(30, 'Too Long!').required('Tracking Number is required'),
    courierInfo: Yup.string().max(50, 'Too Long!').nullable(),
})
    .required();
exports.updateShippingAddressSchema = Yup.object()
    .shape({
    addressLine1: Yup.string().min(1, 'Too Short!').max(60, 'Too Long!').required('Address is required'),
    addressLine2: Yup.string().nullable().max(60, 'Too Long!'),
    houseUnit: Yup.string().nullable(),
    city: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('City is required'),
    postalCode: Yup.string()
        .required('Postal code is required')
        .matches(/^[0-9]+$/, 'Must be only digits')
        .min(5, 'Must be exactly 5 digits')
        .max(5, 'Must be exactly 5 digits'),
    state: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('State is required'),
})
    .required();
exports.FLDFAQSchema = Yup.object().shape({
    category: Yup.string().min(3, 'Too Short!').max(30, 'Too Long!').required('Category is required'),
    question: Yup.string().min(5, 'Too Short!').max(160, 'Too Long!').required('Question is required'),
    answer: Yup.string().min(5, 'Too Short!').required('Answer is required'),
});
//# sourceMappingURL=AdminFLD.js.map